import { Component, inject, OnInit, PLATFORM_ID } from '@angular/core';
import { RouterModule, ActivatedRoute } from '@angular/router';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { forkJoin } from 'rxjs';
import { TypeModule, VmThemeProviderModule } from '@virginmediao2/momentum-angular';
import { FooterComponent, HeaderComponent } from '@/core';
import { SidenavComponent } from '@/core/sidenav';
import { CampaignContentService, StrapiCoreService } from '@/shared/services';
import { environment } from '@/environment';
import { StrapiInterface } from '@/shared/interfaces';
import { AuthService } from '@/shared/services/auth.service';
import { RemoveFromViewDirective } from '@/shared/directives/remove-from-view/remove-from-view.directive';

@Component({
  standalone: true,
  imports: [
    RouterModule,
    VmThemeProviderModule,
    TypeModule,
    CommonModule,
    HeaderComponent,
    SidenavComponent,
    FooterComponent,
    RemoveFromViewDirective,
  ],
  selector: 'vm-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  title = 'Check';

  private strapiCoreService = inject(StrapiCoreService);
  private authService = inject(AuthService);
  private isBrowser = isPlatformBrowser(inject(PLATFORM_ID));
  private route = inject(ActivatedRoute);
  private campaignContentService = inject(CampaignContentService);
  protected environment = environment;
  public navigations: StrapiInterface['navigation'];
  public footer: StrapiInterface['footer'];

  ngOnInit() {
    this.campaignContentService.captureCampaignCode();
    
    if (this.isBrowser) {
      this.route.queryParams.subscribe((params) => {
        if (environment.production === false) {
          const dapiTestActionCode = params['dapiTestActionCode'];
          if (dapiTestActionCode) {
            sessionStorage.setItem('vmo2_zeus_dapiTestActionCode', dapiTestActionCode);
          }
        }
      });
      this.authService.initialise();
    }
    this.fetchContent();
  }

  fetchContent(): void {
    forkJoin({
      footer: this.strapiCoreService.getFooterContent(),
      navigations: this.strapiCoreService.getNavigationContent(),
    }).subscribe(({ footer, navigations }) => {
      this.footer = footer;
      // @ts-ignore
      this.navigations = navigations as StrapiInterface['navigation'];
    });
  }
}
